import React from 'react';
import { NEU_BG, NEU_RAISED, BORDER_SUBTLE, ACCENT, TEXT_FAINT, TEXT_SECONDARY, TEXT_TERTIARY, COLOR_OK, COLOR_DANGER } from '../theme';

function Delta({ curr, prev }) {
  if (prev == null || prev === 0) return null;
  const pct = Math.round((curr - prev) * 100 / prev);
  const up = pct >= 0;
  return (
    <span style={{
      display: 'inline-flex', alignItems: 'center', gap: 2,
      fontSize: 11, fontWeight: 700,
      color: up ? COLOR_OK : COLOR_DANGER,
      background: up ? 'rgba(22,163,74,0.1)' : 'rgba(239,68,68,0.1)',
      padding: '2px 7px', borderRadius: 20, marginTop: 5,
    }}>
      {up ? '↑' : '↓'} {Math.abs(pct)}%
    </span>
  );
}

const StatCard = ({ title, value, subtitle, color, icon, main, curr, prev }) => (
  <div style={{
    background: NEU_BG,
    borderRadius: 16,
    padding: '20px 24px',
    boxShadow: NEU_RAISED,
    border: `1px solid ${BORDER_SUBTLE}`,
    flex: '1 1 0',
    minWidth: 150,
    position: 'relative',
    overflow: 'hidden',
  }}>
    {main && (
      <div style={{
        position: 'absolute', top: 0, right: 0, left: 0, height: 3,
        background: ACCENT, borderRadius: '16px 16px 0 0',
      }} />
    )}
    <div style={{
      fontSize: 10, fontWeight: 700, letterSpacing: 0.8,
      textTransform: 'uppercase', color: TEXT_FAINT, marginBottom: 8,
    }}>
      {title}
    </div>
    <div style={{
      fontSize: 27, fontWeight: 800,
      color: color || (main ? ACCENT : 'var(--txt)'),
      letterSpacing: -1, lineHeight: 1,
    }}>
      {value}
    </div>
    {prev != null && curr != null && <Delta curr={curr} prev={prev} />}
    {subtitle && !prev && (
      <div style={{ color: TEXT_TERTIARY, fontSize: 12, marginTop: 5 }}>{subtitle}</div>
    )}
  </div>
);

export default StatCard;
